import { GET_PERMISSION_CHECKER, GET_PERMISSION_CHECKER_SUCCESS, GET_PERMISSION_CHECKER_ERROR, GET_PERMISSION_CHECKER_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const PermissionChecker = (state = initialState, action) => {
  switch (action.type) {
    case GET_PERMISSION_CHECKER:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_PERMISSION_CHECKER_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_PERMISSION_CHECKER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_PERMISSION_CHECKER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PermissionChecker;
